import { Popper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useRef } from 'react';
import Actions, {
  ActionsProps,
} from '../../FBApprovalMatrixRoles/components/Actions';

const useStyles = makeStyles({
  popperHolder: {
    height: '100%',
  },
  popper: {
    zIndex: 1400,
  },
});

export const ActionsCell: React.FC<ActionsProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const classes = useStyles();

  return (
    <>
      <div ref={ref} className={classes.popperHolder} />
      {ref.current && (
        <Popper
          open
          placement="bottom-end"
          anchorEl={ref.current}
          className={classes.popper}
        >
          <Actions scrollBehavior="smooth" {...props} />
        </Popper>
      )}
    </>
  );
};
